/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiCreateRegionNameDto,
  ApiRegionNameResponseDto,
  ApiUpdateRegionNameDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class RegionName<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * @description Create region name
   *
   * @tags Region name
   * @name RegionNameControllerCreateRegionName
   * @summary Create region name
   * @request POST:/region-name
   * @secure
   * @response `201` `ApiRegionNameResponseDto`
   */
  regionNameControllerCreateRegionName = (
    data: ApiCreateRegionNameDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiRegionNameResponseDto, ApiBaseError>({
      path: `/region-name`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Get all region names
   *
   * @tags Region name
   * @name RegionNameControllerGetAllRegionNames
   * @summary Get all region names
   * @request GET:/region-name
   * @secure
   * @response `200` `(ApiRegionNameResponseDto)[]`
   */
  regionNameControllerGetAllRegionNames = (params: RequestParams = {}) =>
    this.request<ApiRegionNameResponseDto[], ApiBaseError>({
      path: `/region-name`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Get all available region names by plan
   *
   * @tags Region name
   * @name RegionNameControllerGetAvailableRegions
   * @summary Get all available region names by plan
   * @request GET:/region-name/available
   * @secure
   * @response `200` `(ApiRegionNameResponseDto)[]`
   */
  regionNameControllerGetAvailableRegions = (params: RequestParams = {}) =>
    this.request<ApiRegionNameResponseDto[], ApiBaseError>({
      path: `/region-name/available`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Get region name by id
   *
   * @tags Region name
   * @name RegionNameControllerGetRegionNameById
   * @summary Get region name by id
   * @request GET:/region-name/{id}
   * @secure
   * @response `200` `ApiRegionNameResponseDto`
   */
  regionNameControllerGetRegionNameById = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.request<ApiRegionNameResponseDto, ApiBaseError>({
      path: `/region-name/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Delete region name by id
   *
   * @tags Region name
   * @name RegionNameControllerDeleteRegionNameById
   * @summary Delete region name by id
   * @request DELETE:/region-name/{id}
   * @secure
   * @response `200` `boolean`
   */
  regionNameControllerDeleteRegionNameById = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.request<boolean, ApiBaseError>({
      path: `/region-name/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Update region name by id
   *
   * @tags Region name
   * @name RegionNameControllerUpdateRegionNameById
   * @summary Update region name by id
   * @request PATCH:/region-name/{id}
   * @secure
   * @response `200` `ApiRegionNameResponseDto`
   */
  regionNameControllerUpdateRegionNameById = (
    id: number,
    data: ApiUpdateRegionNameDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiRegionNameResponseDto, ApiBaseError>({
      path: `/region-name/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Get region name by region code
   *
   * @tags Region name
   * @name RegionNameControllerGetRegionNameByCode
   * @summary Get region name by region code
   * @request GET:/region-name/code/{code}
   * @secure
   * @response `200` `ApiRegionNameResponseDto`
   */
  regionNameControllerGetRegionNameByCode = (
    code: string,
    params: RequestParams = {},
  ) =>
    this.request<ApiRegionNameResponseDto, ApiBaseError>({
      path: `/region-name/code/${code}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
